__turbopack_context__.v({
  "tableLoading": "TableLoading-module__xFGECa__tableLoading",
});
